import { CompiledReference } from '../traversable.js';
export function parseReference(collectionRef) {
    switch (typeof collectionRef) {
        case 'function':
            return root => collectionRef.call(root);
        case 'object':
            return () => collectionRef;
        case 'string':
            const { resolve } = new CompiledReference(collectionRef);
            return resolve;
    }
}
//# sourceMappingURL=commons.js.map